import { GoogleMap } from '@lib/geo/google/map';

import { MapBaseOverlay } from '../base-overlay';
import { IClusterLayerOptions } from './cluster-layer-options';

export class GoogleMapDataLayer extends MapBaseOverlay {
  private _googleDataLayer: google.maps.Data;
  private _label: google.maps.InfoWindow;
  private _map: GoogleMap;

  constructor(options?: IClusterLayerOptions) {
    super();
    this._googleDataLayer = new google.maps.Data();
  }

  get dataLayerInstance(): google.maps.Data {
    return this._googleDataLayer;
  }

  public loadGeoJson(url: string): void {
    this._googleDataLayer.loadGeoJson(url);
  }

  public addGeoJson(geoJson: Object, options?: google.maps.Data.GeoJsonOptions): void {
    this._googleDataLayer.addGeoJson(geoJson, options);
  }

  public setStyle(options: any): void {
    this._googleDataLayer.setStyle(options);
  }

  public overrideStyle(feature: any, style: any): void {
    this._googleDataLayer.revertStyle();
    this._googleDataLayer.overrideStyle(feature, style);
  }

  public revertStyle(): void {
    this._googleDataLayer.revertStyle();
  }

  public showLabel(latLng: google.maps.LatLng, title: string): void {
    if (!this._map) {
      return;
    }
    if (this._label) {
      this._label.close();
    }
    this._label = new google.maps.InfoWindow({
      content: `<h4 style="margin: 5px;">${title}</h4>`,
      position: latLng,
      disableAutoPan: true,
    });
    this._label.open(this._map.mapInstance);
  }

  public removeLabel(): void {
    if (!this._map) {
      return;
    }
    if (this._label) {
      this._label.close();
    }
  }

  protected onAdd(map: GoogleMap): void {
    this._map = map;
    this._googleDataLayer.setMap(map.mapInstance);
    this._googleDataLayer.addListener('mouseover', (event) => this.fire('mouseover', event));
    this._googleDataLayer.addListener('mouseout', (event) => this.fire('mouseout', event));
    this._googleDataLayer.addListener('click', (event) => this.fire('click', event));
    this._googleDataLayer.addListener('rightclick', (event) => this.fire('rightclick', event));
  }

  protected onRemove(): void {
    if (this._googleDataLayer) {
      this._googleDataLayer.setMap(null);
    }
  }

  protected draw(): void {}
}
